<template>
    <div class="medical-details-info" >
        <div class="details search-details " v-loading="loading">
            <div class="details-info" >
                <el-form class="info-form" v-if='infoData'>
                    <div class="info-top">
                        <div class="top-tit" v-if='infoData.tcmMedicineDiagnose||infoData.wcmMedicineDiagnose'>
                            <span v-html="infoData.tcmMedicineDiagnose?infoData.tcmMedicineDiagnose:infoData.wcmMedicineDiagnose"></span>
                            <span v-if='infoData.doctorName' v-html='"— —"+infoData.doctorName'></span>  
                        </div>
                        <div class="top-tit"  v-else>无标题</div>
                        <div class="top-author"><span>医案库信息：{{infoData.medicalLibraryId}}</span> <span>访问次数：{{infoData.loadnum}}</span> </div>
                    </div>
                    <!-- 20250224 修改为只展示医案原文 -->
                    <!-- <el-form-item v-if="infoData.visitTimes&&Number(infoData.visitTimes)!=0" label="诊次："  :label-width="labelWidth">
                        <div v-html='infoData.visitTimes'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.doctorName" label="医师姓名："  :label-width="labelWidth">
                        <div v-html='infoData.doctorName'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.symptom" label="临床表现："  :label-width="labelWidth">
                        <div v-html='infoData.symptom'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.tongueNature" label="舌质："  :label-width="labelWidth">
                        <div v-html='infoData.tongueNature'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.tongueCoating" label="舌苔："  :label-width="labelWidth">
                        <div v-html='infoData.tongueCoating'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.pulseCondition" label="脉象："  :label-width="labelWidth">
                        <div v-html='infoData.pulseCondition'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.wcmMedicineDiagnose" label="西医疾病："  :label-width="labelWidth">
                        <div v-html='infoData.wcmMedicineDiagnose'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.tcmMedicineDiagnose" label="中医疾病："  :label-width="labelWidth">
                        <div v-html='infoData.tcmMedicineDiagnose'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.tcmSyndrome" label="中医证候："  :label-width="labelWidth">
                        <div v-html='infoData.tcmSyndromeTypeDiagnose'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.formulaName" label="方剂名称："  :label-width="labelWidth">
                        <div v-html='infoData.formulaName'></div> 
                    </el-form-item>
                    <el-form-item v-if="infoData.formulaComposition" label="中药组成："  :label-width="labelWidth">
                        <div v-html='infoData.formulaComposition'></div> 
                    </el-form-item> -->
                    <el-form-item v-if="infoData.medicaltext" label="医案原文："  :label-width="labelWidth">
                        <div v-html='infoData.medicaltext'></div> 
                    </el-form-item>
                    <!-- <el-form-item v-if="infoData.source" label="医案来源："  :label-width="labelWidth">
                        <div v-html='infoData.source'></div> 
                    </el-form-item>
                    <el-form-item v-if='infoData.courseOfDiseaseUnit' label="加工编码："  :label-width="labelWidth">
                        <div v-html='infoData.courseOfDiseaseUnit'></div>
                    </el-form-item>  -->
                    <!-- <el-form-item v-if="upFileList.length!=0" label="附件："  :label-width="labelWidth">
                        
                        <template  >
                            <div class="down-file" @click="down_file(item)" v-for="(item,index) in upFileList" :key="index">
                                <span>{{ item.yuan }}</span>
                            </div>
                        </template>
                    </el-form-item>
                    <el-form-item v-if="infoData.remark" label="备注："  :label-width="labelWidth">
                        {{infoData.remark}}
                    </el-form-item> -->
                </el-form>
                <!-- <div class="back-btn">
                    <el-button @click="back_btn">返回上一页</el-button>
                </div> -->
                
            </div>
        </div>
    </div>
</template>

<script>
import {caseGetCaseInfot,getInfo_bj,getPoolInfoById,downFileById} from '../../io/api.js'

import axios from 'axios';
export default {
    data () {
        return {
            loading:false,
            id:'',
            type:'',
            labelWidth:'140px',
            infoData:{},
            upFileList:[],
            keyword:this.$route.query.keyWord||'',
        }
    },
    mounted () {
        this.getInit()  
    },
    methods: {
        getInit(){
            //medical医案库，standard标准化库里的已标准化,standard_record标准化库里的医案库
            this.id = this.$route.query.id;
            this.type = this.$route.query.type;
            this.getInfo();

        },
        //检索--获取医案详情
        getInfo(){
            this.loading=true;
            let params={
                id:this.id,
                keyword:this.keyword
            }
            https://ai.tcmcds.com/ckcest/consilia/info/{id}
            this.$http.get(`/ckcest/consilia/info/${this.id}`).then(res=>{
                let data = res.data;
                if(data && data.code ==0){ 
                    this.infoData = data.consilia;
                    let attachmentArr=[];
                    let attachmentDownArr=[];
                    // 先把目录的名称，链接改变成arr格式
                    if(this.infoData.attachment&&this.infoData.attachment!=''){
                        attachmentArr=[].concat(this.infoData.attachment!=''&&this.infoData.attachment.split('#'));
                    }
                    if(this.infoData.attachmentDown&&this.infoData.attachmentDown!=''){
                        attachmentDownArr=[].concat(this.infoData.attachmentDown!=''&&this.infoData.attachmentDown.split('#'));
                    }
                    if (attachmentArr&&attachmentArr.length!=0) {
                        attachmentArr.forEach((item,index) => {
                            let nameObj = {
                                yuan:item,
                                hou:attachmentDownArr[index],
                            }
                            this.upFileList.push(nameObj)
                        });
                    }
                }else{
                    this.$message.error(data.msg||'请求失败～');
                }
                this.loading=false;
            })
        },
        //标准库详情
        standard_info(){
            getInfo_bj({id:this.id}).then(res=>{
                let data = res.data;
                if (data && data.code == 0) {
                   this.infoData = data.data;
                }else{
                   this.$message.error(data.msg||'请求失败～');
                }
            })
        },
        down_file(item){
            let param={
                fileName:item.yuam,
                id:this.id,
            }
            downFileById(param).then(res=>{

            })
            let strUrl =  `${this.$store.state.httpUrl}/yiankb-mystore/yacj/downFileById?fileName=${item.yuam}&id=${this.id}`;
            axios({
                method: "get",
                data: param,
                responseType: "blob",
                url:strUrl
            }).then(res=>{
                {
                    let typeCount = {
                        type: "application/octet-stream",
                    };
                    let _this=this;
                    let blob = new Blob([res.data],typeCount);
                    // if (res.data.type != typeCount.type) {
                    //     // 说明是普通对象数据，后台转换失败
                    //     const fileReader = new FileReader()
                    //     fileReader.readAsText(blob,'utf-8')

                    //     fileReader.onload = function () {
                    //         let msg=JSON.parse(fileReader.result).msg;
                    //         _this.$message.error(msg);
                    //         _this.isDerive = false;
                    //         return
                    //     } 
                        
                    // }else{
                        let fileName = res.headers["content-disposition"]&&res.headers["content-disposition"]
                            .split("filename=")
                            .pop();
                        fileName = decodeURI(fileName);
                        let url = window.URL.createObjectURL(blob);
                        let link = document.createElement("a");
                        link.style.display = "none";
                        link.href = url;
                        link.setAttribute("download", item.yuan);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        this.isDerive = false;
                    // }
                    
                }
                // if(blom) return;
            }).catch(err => {
                console.log(err)
            })
        },
        // 分析池详情
        analysis_info(){
            getPoolInfoById({id:this.id}).then(res=>{
                let data = res.data;
                if(data && data.code ==0){
                    this.infoData = data.data;
                }else{
                    this.$message.error(data.msg||'请求失败～');
                }
            })
        },
        back_btn(){
            if(this.type=='analysis'){
                this.$store.state.titleType=3;
            }
            window.history.back();
        }
    },
    
}
</script>

<style lang='less'>
    @import '../../css/search_details/search_details.less';
    
</style>
<style lang="less" scoped>
.search-details{
    .info-top{
        text-align: center; 
        .top-tit{
            font-size: 20px;
            font-weight: bold;
            text-align: center;
        }
        .top-author {
            font-size: 16px;   
            text-align: center;
            margin: 30px;
            padding-bottom: 20px;
            border-bottom: 1px dashed #79bbff;
            span{
                margin-left: 40px;
            }
        }
    }
    .details-info{
        padding:30px 30px 30px 10px;
    }
}
</style>